<template>
  
  <v-app>

      <v-app-bar
        app
        color="indigo darken-4"
        dark
        mt-0
      >

        <div class="d-flex align-center">
  <!--         <v-img
            alt="Vuetify Logo"
            class="shrink mr-2"
            contain
            src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
            transition="scale-transition"
            width="40"
          /> -->

          <!-- <v-img
            alt="Vuetify Name"
            class="shrink mt-1 hidden-sm-and-down"
            contain
            min-width="400"
            src="./assets/Col_Name.png"
            width="400"
          /> -->
        </div>

        <v-btn small class="indigo darken-4" text :to="{name:'Home'}">
          <span class="mr-2"></span>
          <v-icon>mdi-home</v-icon>
        </v-btn>

      <v-spacer></v-spacer>
      <v-btn small v-if="TipoUsuario === 'Persona' || TipoUsuario === ''" @click="LoginPersona"    class="indigo darken-4" >Personas</v-btn>
      <v-btn small v-if="TipoUsuario === 'Empresa' || TipoUsuario === ''" @click="LoginReclutador" class="indigo darken-4 ml-3" >Empresas</v-btn>
      <v-btn small v-if="TipoUsuario === 'Administrador'" class="indigo darken-4 ml-3" >Bienvenido: Administrador</v-btn>
 
      <!--      <v-btn small class="indigo darken-4 ml-3">Empresas</v-btn>
      <v-btn small class="indigo darken-4 ml-3">Salarios</v-btn> -->

      <v-spacer></v-spacer>
      
      <v-btn small v-if="VarLogin == 1 && TipoUsuario == 'Persona'" class="blue darken-1" :to="{name:'areapersona'}">
        Bienvenido: <v-icon v-if="TipoUsuario == 'Persona' || TipoUsuario == ''" >mdi-account</v-icon>
        <v-icon v-if="TipoUsuario == 'Empresa' || TipoUsuario == ''" >mdi-home-modern</v-icon>
        <span class="mr-0 ">{{NombreUsuario.toLowerCase()}}</span>
      </v-btn>

      <v-btn small v-if="VarLogin == 1 && TipoUsuario == 'Empresa'" class="blue darken-1" :to="{name:'reclutadores'}">
        <v-icon v-if="TipoUsuario == 'Persona' || TipoUsuario == ''" >mdi-account</v-icon>
        <v-icon v-if="TipoUsuario == 'Empresa' || TipoUsuario == ''" >mdi-home-modern</v-icon>
        <span class="mr-0 ">{{NombreUsuario.toLowerCase()}}</span>
      </v-btn>       

      <v-spacer></v-spacer>

        <v-btn v-if="TipoIngreso == 'Persona' " :to="{name:'login'}" small class="blue lighten-4 red--text" >
          <span class="mr-2">Ingreso Personas </span>
          <v-icon>mdi-login</v-icon>
        </v-btn>

        <v-btn v-if="TipoIngreso == 'Empresa'" small class="teal lighten-4 red--text" :to="{name:'login'}">
          <span class="mr-2">Ingreso Reclutadores </span>
          <v-icon>mdi-login</v-icon>
        </v-btn>

        <v-btn small @click="cerrarSession()" class="dark" text>
        <span class="mr-2">Cerrar Sesión</span> 
        <v-icon>mdi-logout</v-icon>
        </v-btn>


      </v-app-bar>


    <v-main>
      <router-view/>
    </v-main>

    <br/>


  <v-footer dark padless>
    <v-card
      text
      tile
      class="indigo darken-4 white--text text-center"
      width="100%"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon.icon"
          class="mx-4 white--text"
          icon
           @click="goToSocial(icon.url)"
        >
          <v-icon color="yellow" icon size="30px" >
            {{ icon.icon }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text >
        contacto@colegiodeodontologos.org  |  +601 805 7146  |  Cra. 7 # 127 – 48, Oficina 304 Bogotá D.C.

      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>https://colegiodeodontologos.org/</strong>
      </v-card-text>
    </v-card>
  </v-footer>


  </v-app>

  
</template>

<script>

import auth from "@/auth";
import store from "./store/index.js";
import {mapMutations, mapState} from 'vuex';

export default {
  name: 'App',

  data: () => ({
    //
    icons: [
    { icon: 'mdi-facebook', url: 'https://www.facebook.com/colegiocoldeodontologos' },
    { icon: 'mdi-twitter', url: 'https://x.com/colodontologos' },
    { icon: 'mdi-instagram', url: 'https://www.instagram.com/colegiocolombianodontologos' },
    { icon: 'mdi-linkedin', url: 'https://www.linkedin.com/company/colegiocolombianodeodontologos'},
    { icon: 'mdi-youtube', url: 'https://www.youtube.com/@ccodontologos'}
    ],    
  }),
      methods:{
      
    goToSocial(url) {
      window.open(url, '_blank'); // Abre la URL en una nueva pestaña
    },

      // Se mapean las mutaciones
      ...mapMutations(['AsignarValorLogin','CambiaLogin','IndicadorActualizacionHV']),

      async cerrarSession() {        
        try {
          this.TipoIngreso === ""
          await auth.deleteUserLogged();
          store.commit('AsignarValorLogin', { ValorLogin: 0, user:'',tipousuario :'' });

          // this.$router.replace("/login")  
          this.$router.push("/login").catch(()=>{});          
  
          
        } catch (error) {
          console.log(error);
        } 
    },

/*     CambiaIndicadorActHV(){
      store.commit('IndicadorActualizacionHV', { valor: false });
    }, */

    LoginReclutador(){
      this.$router.push("/empresas").catch(()=>{});
      store.commit('CambiaLogin', { TipoIngreso: "Empresa" });
    },
    LoginPersona(){
      this.$router.push("/personas").catch(()=>{});
      store.commit('CambiaLogin', { TipoIngreso: "Persona" });
    },
  },
  computed: 
  {
      userLogged() {
        return auth.getUserLogged();
      },

  ...mapState(['VarLogin','NombreUsuario','TipoIngreso','TipoUsuario'])
  }
  
};
</script>
